<template>
  <div>
    <Head />
    <div class="wrap">
      <div class="cont">
        <div class="left">
          <h1>Удаление зубов мудрости</h1>
          <p>
            Показания:
          </p>
          <ul>
            <li>потеря основной части зубной ткани без возможности восстановления;</li>
            <li>сильное разрушение коронковой и особенно поддесневой части, когда невозможно сохранить зуб ни при помощи терапии (поставить пломбу), ни при помощи ортопедии (поставить культевую вкладку и покрыть коронкой);</li>
            <li>дистопированный (находящийся не на своем месте) зуб, с отсутствием доступа к нему для ухода или лечения;</li>
            <li>сильный наклон зубов, выдвижение, мешающее протезированию, травмирование рядом лежащих мягких тканей;</li>
            <li>затрудненность доступа для эффективного лечения;</li>
            <li>перелом корня зуба впоследствии травмы;</li>
            <li>инфекция, поражающая корень зуба;</li>
            <li>пародонтит тяжелой степени;</li>
            <li>неправильный процесс прорезывания зуба мудрости.</li>
          </ul>
          <br>
          <p>
            Противопоказания:
          </p>
          <ul>
            <li>постинфарктное состояние;</li>
            <li>инфекционное или вирусное заболевание;</li>
            <li>гипертония;</li>
            <li>беременность (первые месяцы и последний).</li>
          </ul>
          <br>
          <p>
            Основные рекомендации после удаления зуба:
          </p>
          <ul>
            <li>следует воздержаться от приема пищи в течении 2-3 часов;</li>
            <li>воздерживаться от приема горячей, особенно горячей жидкой пищи;</li>
            <li>не делать усиленных полосканий;</li>
            <li>чистку зубов проводить на следующий день;</li>
            <li>стараться принимать пищу на противоположной стороне от удаленного зуба;</li>
            <li>не прикасаться к лунке языком и какими-либо предметами.</li>
          </ul>        
          <br>
          <p>
            Более подробную консультацию Вы можете получить, обратившись к нам. 
          </p>
          <br><br>
        </div>
          <a-carousel autoplay arrows effect="fade">
            <template #prevArrow>
              <div class="custom-slick-arrow" style="left: 10px; z-index: 1">
                <left-circle-outlined />
              </div>
            </template>
            <template #nextArrow>
              <div class="custom-slick-arrow" style="right: 10px">
                <right-circle-outlined />
              </div>
            </template>
            <div><img class='ii' alt="" src="../assets/pa1.jpg" /></div>
            <div><img class='ii' alt="" src="../assets/pa2.jpg" /></div>
            <div><img class='ii' alt="" src="../assets/pa3.jpg" /></div>
            <div><img class='ii' alt="" src="../assets/pa4.jpg" /></div>
          </a-carousel>
      </div>
    </div>
    <Foot />
  </div>
</template>

<script>
import Head from '@/components/Head.vue'
import { Carousel } from 'ant-design-vue';
import { LeftCircleOutlined, RightCircleOutlined } from '@ant-design/icons-vue';
import Foot from '@/components/Foot.vue'

export default {
  name: 'OrthopedicsView',
  components: {
    Head,
    Foot,
    ACarousel: Carousel,
    LeftCircleOutlined, 
    RightCircleOutlined,
  }
}
</script>

<style scoped>

.wrap {
  max-width: 90%;
  margin: 60px auto;
  min-height: 500px;
}

.cont {
  margin: 60px auto;
  margin-bottom: 140px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(520px, 1fr));
}

.left {
  margin-right: 30px;
}

p {
  width: 95%;
}

.ii {
  width: 100%;
  height: 450px;
  overflow: hidden;
  object-fit: cover;
}

.ant-carousel :deep(.slick-slide) {
  text-align: center;
  height: 450px;
  line-height: 160px;
  overflow: hidden;
}

.ant-carousel :deep(.slick-slide h3) {
  color: #fff;
}

.ant-carousel :deep(.slick-arrow.custom-slick-arrow) {
  width: 35px;
  height: 25px;
  font-size: 35px;
  color: #fff;
  background-color: rgba(31, 45, 61, 0.11);
  opacity: 0.3;
  z-index: 1;
}

.ant-carousel :deep(.custom-slick-arrow:before) {
  display: none;
}

.ant-carousel :deep(.custom-slick-arrow:hover) {
  opacity: 0.5;
}

@media (max-width: 790px) {

.cont {
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
}

}

</style>

